import * as React from "react";
import TrustPilot from "./TrustPilot";
import BasketContext from "../services/BasketContext";

function EmptyBasket(props: {
	wishlistItemCount: number
}) {

	const basketContext = React.useContext(BasketContext);

	React.useEffect(() => {

		if (document) {
			const sectionContainer = document.querySelector('.js-basket-section-container');
			sectionContainer.classList.remove('c-section--category');
			sectionContainer.classList.remove('c-section--basket');
			sectionContainer.classList.add('c-section--center');
			sectionContainer.classList.add('c-section--tight-top');
		}

	}, []);


	return (
		<React.Fragment>
			<p className="h1 u-mb15">There are no items in your basket.</p>
			{props.wishlistItemCount > 0 ?
				<p className="h1 u-mb15" data-test="basket-wishlist-items-text">You have {props.wishlistItemCount} item{props.wishlistItemCount > 1 ? 's' : ''} in your wishlist.</p>
				: null}
			<div className="c-basket--empty__actions">
				<p className="c-basket--empty__actions__container">
					{props.wishlistItemCount > 0 ?
					<a href="/wishlist" className="c-button c-button--large c-button--outline" data-test="basket-view-wishlist">View Wishlist</a>
						: null}
					<a href="/" className="c-button c-button--large c-button--emphasize" data-test="basket-continue-shopping-link-small">Continue shopping</a>
				</p>
			</div>
			<TrustPilot {...basketContext.basket.BasketTrustpilotModel} />
		</React.Fragment>
	);


}

export default EmptyBasket;
